module.exports = __webpack_public_path__ + "static/media/tm-color-sm.1d5eff70.webp";